<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 19:00:33
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-11-15 14:45:49
-->
<template>
  <div class="index-news wh100">
    <div class="index-news-bj">
      <img :src="require('@/assets/images/pc/index/news.png')" alt="">
      <div class="circle circle1"><div class="animate"></div></div>
      <div class="circle circle2"><div class="animate"></div></div>
      <div class="circle circle3"><div class="animate"></div></div>
    </div>
    <div class="container index-news-box wh100">
      <div :class="['index-news-title', realIndex === activeIndex ? 'transition' : '']">
        <div class="ui-title p-t-10">{{ $t('frontPage.news.title') }}</div>
        <div class="ui-des">{{ $t('frontPage.news.des') }}</div>
      </div>
      <div class="flex index-news-main">
        <a :class="['flex_1 index-news-item', index == 0 ? 'left' : 'right', realIndex === activeIndex ? 'transition' : '']" v-for="(item, index) in $t('frontPage.news.dynamicData')" :key="`dsf_${index}`" :href="item.url" target="_blank">
          <div class="index-news-item-img">
            <div class="wh100 overhid">
              <el-image class="transition2 wh100" :src="item.poster" alt="" srcset=""  fit="cover"/>
            </div>
          </div>
          <div class="">
            <div class="clearfix">
              <div class="index-news-item-num time fl">{{item.time}}</div>
              <div class="index-news-item-title ellipsis fl" v-html="item.title"></div>
            </div>
            <div class="clearfix">
              <div class="index-news-item-num fl">{{item.year}}</div>
              <div class="index-news-item-des ellipsis fl" v-html="item.des"></div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    realIndex: {
      type: Number,
      default: 0
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  mounted () {}
}
</script>

<style lang="less" scoped>
.index-news {
  color: #333333;
  padding-top: 90PX;
  .index-news-bj {
    width: 100%;
    height: 90%;
    position: absolute;
    top: 110PX;
    img {
      width: 92%;
      // height: 100%;
      padding-left: 8%;
      opacity: 0.5;
    }
    .circle {
      position: absolute;
      width: 8PX;
      height: 8PX;
      border-radius: 50%;
      background: #00A0E9;
      opacity: 0.5;
      z-index: 2;
      .animate {
        width: 26PX;
        height: 26PX;
        border-radius: 50%;
        background: #00A0E9;
        position: absolute;
        opacity: 1;
        left: -9PX;
        top: -9PX;
      }
      &.circle1 {
        top: 20%;
        left: 22%;
        .animate {
          animation: newCircle 5s linear 1s infinite;
        }
      }
      &.circle2 {
        top: 10%;
        left: 39%;
        .animate {
          animation: newCircle 3s linear 3s infinite;
        }
      }
      &.circle3 {
        top: 12%;
        right: 22%;
        .animate {
          animation: newCircle 4s linear 2s infinite;
        }
      }
    }
  }
  .index-news-box {
    position: relative;
  }
  .index-news-title {
    position: relative;
    top: 30%;
    opacity: 0;
    &.transition {
      top: 20PX;
      opacity: 1;
      transition: top 1s ease, opacity 1s ease;
    }
  }
  .index-news-main {
    font-size: 18PX;
    position: absolute;
    width: 80%;
    height: 60vh;
    bottom: 10vh;
    .index-news-item {
      line-height: 38PX;
      padding: 36PX 15PX 0 15PX;
      width: 50%;
      position: absolute;
      opacity: 0;
      color: #333333;
      &:hover {
        .el-image {
          transform: scale(1.1);
        }
      }
      &.left {
        left: -50%;
        &.transition {
          left: 0;
          opacity: 1;
          transition: left 1.5s ease, opacity 1.5s ease;
        }
      }
      &.right{
        right: -50%;
        &.transition {
          right: 0;
          opacity: 1;
          transition: right 1.5s ease, opacity 1.5s ease;
        }
      }
      .index-news-item-img {
        padding: 20PX 26PX;
        border: 1PX solid #D6D6D6;
        max-height: 630PX;
        height: 46vh;
        overflow: hidden;
        margin-bottom: 16PX;
        background: #ffffff;
      }
      .index-news-item-num {
        position: absolute;
        color: #000000;
        &.time {
          font-size: 30PX;
          color: #00A0E9;
        }
      }
      .index-news-item-title {
        font-weight: 600;
        padding-left: 100PX;
        width: 100%;
      }
      .index-news-item-des {
        padding-left: 100PX;
        width: 100%;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1600PX) and (min-width: 1400PX) {
  .index-news {
    .index-news-title {
      top: 30%;
      &.transition {
        top: 20PX;
      }
    }
    .index-news-main {
      font-size: 16PX;
      width: 80%;
      height: 56vh;
      bottom: 10vh;
      .index-news-item {
        line-height: 38PX;
        padding: 36PX 15PX 0 15PX;
        width: 50%;
        .index-news-item-num {
          &.time {
            font-size: 26PX;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1400PX) and (min-width: 1366PX) {
  .index-news {
    .index-news-title {
      &.transition {
        top: 60PX;
      }
    }
  }
}
@media screen and (max-width: 1366PX) {
  .index-news {
    .index-news-title {
      top: 30%;
      &.transition {
        top: 10PX;
      }
    }
    .index-news-main {
      font-size: 16PX;
      width: 80%;
      height: 56vh;
      bottom: 10vh;
      .index-news-item {
        line-height: 38PX;
        padding: 36PX 15PX 0 15PX;
        width: 50%;
        .index-news-item-img {
          height: 44vh;
        }
        .index-news-item-num {
          &.time {
            font-size: 26PX;
          }
        }
      }
    }
  }
}

@media screen and (width: 1280PX) and (min-height: 800PX) {
  .index-news {
    .index-news-title {
      &.transition {
        top: 40PX;
      }
    }
    .index-news-main {
      bottom: 13vh;
    }
  }
}
@media screen and (max-height: 500PX) {
  .index-news {
    padding-top: 60PX;
    .index-news-title {
      top: 30%;
      &.transition {
        top: 0;
      }
    }
    .index-news-main {
      font-size: 12PX;
      bottom: 13vh;
      .index-news-item {
        line-height: 26PX;
        padding: 36PX 15PX 0 15PX;
        width: 50%;
        .index-news-item-img {
          height: 44vh;
        }
        .index-news-item-num {
          &.time {
            font-size: 24PX;
          }
        }
      }
    }
  }
}
</style>
